if (!customElements.get('testimonial-showcase')) {
  class TestimonialShowcase extends HTMLElement {
    setup() {
      this.teardown();

      this.panels = this.querySelectorAll('[data-testimonial-panel]');
      this.thumbs = this.querySelectorAll('[data-testimonial-thumb]');
      this.progressSegments = this.querySelectorAll('[data-progress-segment]');
      this.count = this.panels.length;
      if (!this.count) return;

      this.index = 0;
      this.autoplay = this.dataset.autoplay === 'true' && this.count > 1;
      this.speed = (+this.dataset.autoplaySpeed || 5) * 1000;
      this.nav = this.querySelector('.testimonial-showcase__nav');

      if (this.autoplay) {
        this.style.setProperty('--ts-autoplay-duration', this.speed / 1000 + 's');
      }

      this.resetState();

      this._onClick = (e) => {
        const btn = e.target.closest('[data-testimonial-thumb]');
        if (!btn || !this.contains(btn)) return;
        this.show(+btn.dataset.testimonialThumb);
        if (this.autoplay) this.startTimer();
      };
      this.nav?.addEventListener('click', this._onClick);

      if (this.autoplay) {
        this._onVis = () => {
          const fill = this.getActiveFill();
          if (!fill) return;
          if (document.hidden) {
            this.stopTimer();
            fill.classList.add('is-paused');
          } else {
            fill.classList.remove('is-paused');
            this.startTimer();
          }
        };
        document.addEventListener('visibilitychange', this._onVis);
        this.startTimer();
      }
    }

    teardown() {
      this.stopTimer();
      if (this._onClick && this.nav) this.nav.removeEventListener('click', this._onClick);
      if (this._onVis) document.removeEventListener('visibilitychange', this._onVis);
      this._onClick = null;
      this._onVis = null;
    }

    connectedCallback() {
      this.setup();
    }

    disconnectedCallback() {
      this.teardown();
    }

    getActiveFill() {
      return this.progressSegments[this.index]?.querySelector('.testimonial-showcase__progress-fill');
    }

    resetState() {
      this.panels.forEach((panel, i) => {
        const active = i === 0;
        panel.classList.toggle('is-active', active);
        panel.toggleAttribute('hidden', !active);
      });
      this.thumbs.forEach((thumb, i) => {
        const active = i === 0;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      this.index = 0;
      this.updateProgress(true);
    }

    show(i) {
      if (i === this.index || i < 0 || i >= this.count) return;
      this.panels[this.index].classList.remove('is-active');
      this.panels[this.index].hidden = true;
      this.thumbs[this.index].classList.remove('is-active');
      this.thumbs[this.index].setAttribute('aria-current', 'false');
      this.index = i;
      this.panels[i].classList.add('is-active');
      this.panels[i].hidden = false;
      this.thumbs[i].classList.add('is-active');
      this.thumbs[i].setAttribute('aria-current', 'true');
      if (this.autoplay) this.updateProgress(true);
    }

    updateProgress(restart) {
      if (!this.progressSegments.length) return;

      this.progressSegments.forEach((segment, i) => {
        const fill = segment.querySelector('.testimonial-showcase__progress-fill');
        const isActive = i === this.index && this.autoplay;

        segment.classList.toggle('is-active', isActive);
        fill?.classList.remove('is-paused');

        if (!fill) return;

        if (isActive && restart) {
          fill.style.animation = 'none';
          fill.style.width = '0';
          void fill.offsetWidth;
          fill.style.animation = '';
          return;
        }

        fill.style.animation = 'none';
        fill.style.width = '0';
      });
    }

    startTimer() {
      this.stopTimer();
      this.updateProgress(true);
      this.timer = setInterval(() => this.show((this.index + 1) % this.count), this.speed);
    }

    stopTimer() {
      clearInterval(this.timer);
    }
  }

  customElements.define('testimonial-showcase', TestimonialShowcase);

  const getSectionRoot = (event) => {
    const sectionId = event.detail?.sectionId;
    if (sectionId) {
      const section = document.getElementById('shopify-section-' + sectionId);
      if (section) return section;
    }
    return event.target;
  };

  const reinitShowcases = (root) => {
    if (!root?.querySelectorAll) return;
    root.querySelectorAll('testimonial-showcase').forEach((el) => el.setup());
  };

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => reinitShowcases(getSectionRoot(e)));
    document.addEventListener('shopify:section:reorder', (e) => reinitShowcases(getSectionRoot(e)));
    document.addEventListener('shopify:block:select', (e) => {
      const showcase = document.querySelector(
        'testimonial-showcase[data-section-id="' + e.detail.sectionId + '"]'
      );
      if (!showcase) return;
      const panel = showcase.querySelector('#shopify-block-' + e.detail.blockId);
      if (panel) showcase.show(+panel.dataset.testimonialPanel);
    });
  }
}
